import { Flex, Heading } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import ClockIcon from "../../../assets/clock.svg?react";

export function CheckoutPending() {
  const { t } = useTranslation(undefined, { lng: "tr" });

  return (
    <Flex
      justify="center"
      align="center"
      direction="column"
      className="w-full h-full p-2 py-12"
    >
      <figure className="flex justify-center overflow-hidden">
        <ClockIcon />
      </figure>
      <Flex mt="4" gap="4" justify="center" align="center">
        <Heading
          align="center"
          size="8"
          weight="bold"
          color="gray"
          mb="2"
          highContrast
        >
          {t("paymentProcessing")}
        </Heading>
      </Flex>
      <Flex px="8">
        <Heading
          align="center"
          size="7"
          weight="medium"
          color="gray"
          highContrast
        >
          {t("waitForDoorOpen")}
        </Heading>
      </Flex>
    </Flex>
  );
}
